import React from 'react';
import { Card } from 'react-bootstrap';
import * as LuIcon from 'react-icons/lu';

import { useTranslation } from '../../../translations';
import {
  StepErrorDto,
  StepErrorDtoLevelEnum,
} from '../../../common/pokCore/autogenerated/pokApiClient';

interface StageModalInfoProps {
  items: StepErrorDto[];
}

export const StageModalInfo: React.FC<StageModalInfoProps> = ({ items }) => {
  const { t, tk } = useTranslation('projectLng');

  if (items.length === 0) {
    return null;
  }

  return (
    <Card className="stage-modal-card stage-modal-card-info rounded-3">
      {items.filter(item => item.level === StepErrorDtoLevelEnum.Info).length >
        0 && (
        <>
          <h6 className="fw-semibold mb-3 d-flex align-items-center gap-2 text-dark">
            {t(tk.timeLine.information)}
          </h6>
          <div className="d-flex flex-column gap-2 mb-2">
            {items
              .filter(item => item.level === StepErrorDtoLevelEnum.Info)
              .map((item, index) => (
                <div
                  key={index}
                  className={`d-flex align-items-start ms-2 text-primary`}
                >
                  <LuIcon.LuInfo className="me-2 my-1" size={16} />
                  <span
                    className="text-dark pe-1"
                    dangerouslySetInnerHTML={{ __html: item.message }}
                  />
                </div>
              ))}
          </div>
        </>
      )}
      {items.filter(item => item.level === StepErrorDtoLevelEnum.Future)
        .length > 0 && (
        <>
          <h6 className="fw-semibold mb-3 d-flex align-items-center gap-2 text-dark mt-4">
            {t(tk.timeLine.future)}
          </h6>
          <div className="d-flex flex-column gap-2">
            {items
              .filter(item => item.level === StepErrorDtoLevelEnum.Future)
              .map((item, index) => (
                <div
                  key={index}
                  className={`d-flex align-items-start ms-2 text-secondary`}
                >
                  <LuIcon.LuClock className="me-2 my-1" size={16} />
                  <span
                    className="text-dark pe-1"
                    dangerouslySetInnerHTML={{ __html: item.message }}
                  />
                </div>
              ))}
          </div>
        </>
      )}
    </Card>
  );
};
